export enum TransactionType {
  HSEA1 = 'hsea1',
  HSEA2 = 'hsea2',
  HSEA3 = 'hsea3',
  HSEA4 = 'hsea4',
  HSEA1_CORRESPONDENT = 'hsea1_correspondent',
  HSEA2_CORRESPONDENT = 'hsea2_correspondent',
  HSEA3_CORRESPONDENT = 'hsea3_correspondent',
  HSEA1_MORTGAGE_BROKER = 'hsea1_mortgage_broker',
  HSEA2_MORTGAGE_BROKER = 'hsea2_mortgage_broker',
  HSEA3_MORTGAGE_BROKER = 'hsea3_mortgage_broker',
  KPO_ONLY = 'kpo_only',
}

// Display labels for transaction types
export const TRANSACTION_TYPE_LABELS: Record<string, string> = {
  [TransactionType.HSEA1]: 'HSEA1',
  [TransactionType.HSEA2]: 'HSEA2',
  [TransactionType.HSEA3]: 'HSEA3',
  [TransactionType.HSEA4]: 'HSEA4',
  [TransactionType.HSEA1_CORRESPONDENT]: 'HSEA1 Correspondent',
  [TransactionType.HSEA2_CORRESPONDENT]: 'HSEA2 Correspondent',
  [TransactionType.HSEA3_CORRESPONDENT]: 'HSEA3 Correspondent',
  [TransactionType.HSEA1_MORTGAGE_BROKER]: 'HSEA1 Mortgage Broker',
  [TransactionType.HSEA2_MORTGAGE_BROKER]: 'HSEA2 Mortgage Broker',
  [TransactionType.HSEA3_MORTGAGE_BROKER]: 'HSEA3 Mortgage Broker',
  [TransactionType.KPO_ONLY]: 'Purchase Offer',
}

// Known acronyms that should stay uppercase when formatting unknown transaction types
const TRANSACTION_TYPE_ACRONYMS = new Set(['KPO'])

/**
 * Format a transaction type for display
 * Uses explicit label mapping when available, falls back to smart formatting for unknown types
 * @example formatTransactionType('hsea1_mortgage_broker') // 'HSEA1 Mortgage Broker'
 * @example formatTransactionType('kpo_only') // 'KPO Only'
 */
export const formatTransactionType = (type: string | undefined | null): string => {
  if (!type) return ''

  // Check for explicit label mapping first (case-insensitive)
  const lowerType = type.toLowerCase()
  if (TRANSACTION_TYPE_LABELS[lowerType]) {
    return TRANSACTION_TYPE_LABELS[lowerType]
  }

  // Fallback: smart formatting for unknown transaction types
  return type
    .split('_')
    .map((word) => {
      const upperWord = word.toUpperCase()
      // Keep known acronyms uppercase
      if (TRANSACTION_TYPE_ACRONYMS.has(upperWord)) {
        return upperWord
      }
      // Check HSEA with any number suffix (HSEA1, HSEA2, etc.)
      if (/^HSEA\d*$/i.test(word)) {
        return upperWord
      }
      // Title case other words
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(' ')
}
